angular.module('property-deal')
    .controller('PropertyDealStatusToggleController', function ($http, $scope, $rootScope, $uibModalInstance, data, PropertyDeal) {
        this.$onInit = () => {
            this.statuses = PropertyDeal.statuses()
            this.item = data
            this.form = {
                id: data.id,
                status: data.status
            }
        }
        this.onStatusClick = s => {
            this.form.status = s
        }
        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            return PropertyDeal.statusToggle(this.form).$promise.then(result => {
                $rootScope.$broadcast('property-deal.updated', result)
                $uibModalInstance.close(this.form)
            })
        };
    })
